<div
  class="preview-image__item"
  [style.backgroundImage]="'url(' + url() + ')'"
  (click)="imageService.open(currentImage())"
></div>

<i class="icon-arrow-down preview-image__menu-icon" (click)="onToggleMenu()"></i>
@if (isShowMenu()) {
  <ux-context-menu class="preview-image__context-menu" (clickOutside)="onCloseMenu()" [delayClickOutsideInit]="true">
    <ux-context-menu-item
      menu1
      icon="icon-eye"
      iconSize="11.5"
      name="Просмотр"
      (click)="imageService.open(currentImage())"
    >
    </ux-context-menu-item>
    <ux-context-menu-item menu1 icon="icon-download" name="Скачать" (click)="onDownloadFile()"> </ux-context-menu-item>
    <!--<ux-context-menu-item menu1 icon="icon-question" iconSize="13" name="Отправить на почту"></ux-context-menu-item>-->
    <ux-context-menu-item menu1 icon="icon-trash" name="Удалить" (click)="onDeleteImage()"></ux-context-menu-item>
  </ux-context-menu>
}
